import React, { useState } from "react"
import classNames from "@utils/classnames"

import Slider from "react-slick"
import Clickable from "@components/clickable"
import Section from "@components/section"

import styles from "./gameTabs.module.scss"
import arrowImg from "@images/arrow.png"

const sliderOptions = {
  centerMode: true,
  centerPadding: "0px",
  infinite: true,
  speed: 500,
  arrows: true,
  focusOnSelect: true,
}

const Arrow = ({
  className,
  direction = "left",
  slideCount,
  currentSlide,
  ...props
}) => {
  return (
    <Clickable
      className={classNames(className, styles.arrow, {
        [styles.arrowLeft]: direction === "left",
        [styles.arrowRight]: direction === "right",
      })}
      {...props}
    >
      <img src={arrowImg} />
    </Clickable>
  )
}

const GameTabs = ({ games, children }) => {
  const [current, setCurrent] = useState(games[0].key)
  const gamesSize = games.length
  return (
    <Section title="比赛项目">
      <div className={styles.tabs}>
        <Slider
          {...sliderOptions}
          slidesToShow={gamesSize >= 3 ? 3 : gamesSize}
          nextArrow={<Arrow direction="right" />}
          prevArrow={<Arrow direction="left" />}
          afterChange={current => {
            setCurrent(
              games[current >= games.length ? current - games.length : current]
                .key
            )
          }}
        >
          {(gamesSize === 3 ? games.concat(games) : games).map((game, i) => (
            <div key={game.key + i}>
              <Clickable
                className={classNames("box", styles.tab, {
                  "box-blue": current === game.key,
                  "box-blue-dark": current !== game.key,
                })}
              >
                <div>
                  <img src={game.logo} alt={game.key} />
                </div>
              </Clickable>
            </div>
          ))}
        </Slider>
      </div>
      <div className={styles.body}>
        <h3>《 {games.find(g => g.key === current).title} 》</h3>
        <span className={styles.dots}>
          .<br />.<br />.
        </span>
        {children(current)}
      </div>
    </Section>
  )
}

export default GameTabs
